// This file is auto-generated by the build system.
const BuildVersion = "2.5.107";
export default BuildVersion;
